<template>
  <div >
    <el-col :span="4" class="colleft">
      <el-menu default-active="1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        background-color="rgb(51, 99, 151)" text-color="#fff" active-text-color="#ffd04b" router :unique-opened="true">
        <div class="company">
            <!-- <el-avatar :size="50" style="margin-top: 10px;" :src="info.company.logo"></el-avatar> -->
            <el-avatar :size="70" fit="scale-down "  style="margin-top: 10px;">
              <img :src="info.company.logo"  style="width: 100%;"/>
            </el-avatar>
          <!-- <img /> -->
          <h3>{{info.company.name}}</h3>
        </div>
        <el-menu-item @click="change('chome')">
          <template slot="title">
            <i class="el-icon-s-home"></i>
            <span @click="change('chome')">首页</span>
          </template>
        </el-menu-item>
        <el-menu-item >
          <template slot="title">
            <i class="el-icon-s-custom"></i>
            <span  @click="change('section')">组织架构</span>
          </template>
        </el-menu-item>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>培训资源</span>
          </template>
          <el-menu-item @click="change('Yzcourse')">
            药知资源</el-menu-item>
          <el-menu-item @click="change('Selfcourse')">
            内部课程</el-menu-item>
          <el-menu-item @click="change('Selffile')">
            内部文档</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span slot="title">培训管理</span>
          </template>
          <el-menu-item  @click="change('tclass')">培训分类</el-menu-item>
          <el-menu-item   @click="change('resources')">资源包管理</el-menu-item>
          <el-menu-item  @click="change('task')">培训任务</el-menu-item>
          <el-menu-item   @click="change('entry')">入职任务</el-menu-item>
          <el-menu-item  @click="change('offline')" >线下任务</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-s-data"></i>
            <span slot="title">统计中心</span>
          </template>
          <el-menu-item @click="change('censustrain')">任务统计</el-menu-item>
          <el-menu-item @click="change('study')">学习统计</el-menu-item>
          <el-menu-item @click="change('time')">时长统计</el-menu-item>
          <el-menu-item @click="change('operation')">操作记录</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class="el-icon-tickets"></i>
            <span slot="title">测评系统</span>
          </template>
          <el-menu-item @click="change('eva_list')">试卷管理</el-menu-item>
          <el-menu-item @click="change('test_distribute_list')">试卷分发详情</el-menu-item>
        </el-submenu>
        <el-submenu index="7">
          <template slot="title">
            <i class="el-icon-document-checked"></i>
            <span slot="title">调查问卷</span>
          </template>
          <el-menu-item @click="change('quest_list')">问卷列表</el-menu-item>
          <el-menu-item @click="change('quest_data_list')">数据列表</el-menu-item>
        </el-submenu>
        <el-menu-item >
          <template slot="title">
            <i class="el-icon-chat-line-square"></i>
            <span  @click="change('company_consult')">咨询列表</span>
          </template>
        </el-menu-item>
		<el-menu-item >
		  <template slot="title">
		    <i class="el-icon-s-tools"></i>
		    <span  @click="change('Enterprise')">系统设置</span>
		  </template>
		</el-menu-item>
        <div class="rzex">北京睿知而行科技有限公司</div>
      </el-menu>
    </el-col>
    <el-col :span="20" class="colright">

      <navtop></navtop>
    </el-col>

  </div>
</template>

<script>
  import NavTop from './NavTop.vue';

  export default {
    data() {
      return {
        height:'',
        info:this.$store.state.info,
      };
    },
    mounted() {
      this.height=document.documentElement.clientHeight+'px'
    },
    methods: {
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
      change(val) {
        this.$parent.change(val)
      }
    },
    components: {
      navtop: NavTop,
    },
  }
</script>

<style scoped>
  .headimg {
    margin-top: 5px;
  }
  .colleft {
    min-height: 100vh;
    height: 100%;
    background-color: rgb(51, 99, 151);
    min-width: 200px;
    z-index: 9999;
  }

  .colright {
    float: right;
    height: 20px;
    position: relative;
  }

  @media screen and (max-width: 1200px) {
    .colright {
      width: calc(100% - 200px);
    }
  }

  .el-menu {
    min-height: calc(100vh - 100px);
    height: 100%;
    position: relative;
    padding-bottom: 100px;
    border: none;
  }

  i {
    color: white;
  }


  .company {
    overflow: hidden;
    padding: 5px 0;
    text-align:center;
    margin: 20px;
  }

  .company>img {
    width: 5rem;
    height:5rem;


  }

  .company>h3 {
    color: white;
    padding: 5px;
    width: 100%;
    margin: 0;
  }

  .rzex {
    margin: 20px 0;
    width: 100%;
    color: white;
    text-align: center;
    position: absolute;
    bottom: 0;
  }

  >>>.el-menu--inline {
    padding-left: 30px;
  }

  .el-submenu .el-menu-item {
    min-width: 170px !important;
  }

  >>>.el-menu--inline>li {
    width: calc(100% - 30px);
  }
</style>



// WEBPACK FOOTER //
// src/components/company/public/NavLeft.vue